// services/UserEventLog.js
import BaseStrapiCollection from "../base-strapi-collection/base-strapi-collection";
import qs from "qs";

export default class UserEventLog extends BaseStrapiCollection {
    static kind = "collectionType";
    static singularName = "user-event-log";
    static pluralName = "user-event-logs";
    static displayName = "UserEventLog";

    constructor() {
        super(`${UserEventLog.kind}`,`${UserEventLog.singularName}`,`${UserEventLog.pluralName}`, {workspaceScoped: false});}

    async getAll(query = {}) {
        const _query = qs.stringify({...query}, {
            encodeValuesOnly: true, // prettify URL
        });

        return await this.fetch(_query);
    }


    async getById(id, query = {}) {
        return await this.find(id, { populate: "*", ...query });
    }

    async createItem(data) {
        return await this.create(data);
    }

    async updateItem(id, data, query = {}) {
        return await this.update(id, data, query);
    }

    async deleteItem(id) {
        return await this.delete(id);
    }
}
